export default "__VITE_ASSET__17349c18__"